import React, { useState, useEffect } from "react";

import { auth } from "../firebase/firebaseConfig";
import "../pages/Profile.css";
import {getUserProfile, updateUserProfile, uploadProfilePicture} from "../services/userServices";

const Profile = () => {
    const [userData, setUserData] = useState({});
    const [file, setFile] = useState(null);
    const [imageUrl, setImageUrl] = useState("");

    useEffect(() => {
        const fetchProfile = async () => {
            if (auth.currentUser) {
                const data = await getUserProfile(auth.currentUser.uid);
                setUserData(data || {});
            }
        };
        fetchProfile();
    }, []);

    const handleUpdateProfile = async () => {
        await updateUserProfile(auth.currentUser.uid, userData);
        alert("Profile updated!");
    };

    const handleImageUpload = async () => {
        if (file) {
            const url = await uploadProfilePicture(file);
            setImageUrl(url);
            setUserData({ ...userData, profilePicture: url });
            alert("Profile picture updated!");
        }
    };

    return (
        <div className="profile-container">
            <h2>Profile Settings</h2>

            <label>Full Name</label>
            <input
                type="text"
                value={userData.name || ""}
                onChange={(e) => setUserData({...userData, name: e.target.value})}
            />

            <label>Email</label>
            <input type="email" value={auth.currentUser?.email} disabled/>

            <label>Age </label>
            <input
                type="text"
                value={userData.age || ""}
                onChange={(e) => setUserData({...userData, age: e.target.value})}
            />
            <label>Nationality </label>
            <input
                type="text"
                value={userData.nationality || ""}
                onChange={(e) => setUserData({...userData, nationality: e.target.value})}
            />

            <label>Program </label>
            <input
                type="text"
                value={userData.program || ""}
                onChange={(e) => setUserData({...userData, program: e.target.value})}
            />
            <label>Profile Picture</label>
            <input type="file" onChange={(e) => setFile(e.target.files[0])}/>
            <button onClick={handleImageUpload}>Upload Picture</button>

            {imageUrl && <img src={imageUrl} alt="Profile" className="profile-picture"/>}

            <button onClick={handleUpdateProfile}>Save Changes</button>
        </div>
    );
};

export default Profile;
